import { useGate, useStoreMap } from 'effector-react'
import { useParams } from 'react-router-dom'
import {
  debtViewModel,
  ViewDebt,
  LoadingBlock,
  RepayDrawer,
} from '~/features/Debt/ViewDebt'
import { Button } from '~/shared/ui/Buttons'
import { NotFound } from '~/shared/ui/NotFound'
import { PageContainer } from '~/shared/ui/PageContainer'

export function ViewDebtPage() {
  const params = useParams<{ debtId: string }>()
  const paramDebtId = params.debtId as string
  useGate(debtViewModel.Gate, { debtId: paramDebtId })

  const bookingCarId = useStoreMap(debtViewModel.$debt, (debt) =>
    debt?.getApiId(),
  )
  const debtLoaded = bookingCarId === paramDebtId
  const deptError = debtViewModel.useDebtError(paramDebtId)

  if (deptError) {
    return (
      <NotFound
        message='Не удалось загрузить задолженность. Если она только что создана, попробуйте позже.'
        buttonNode={
          <Button
            variant='limeFlooded'
            onClick={() => debtViewModel.requestFx(paramDebtId)}
          >
            Повторить загрузку
          </Button>
        }
      />
    )
  }

  return (
    <PageContainer
      canBack
      backTitle='Текущие задолженности'
      title='Текущие задолженности'
    >
      {debtLoaded ? <ViewDebt /> : <LoadingBlock />}
      <RepayDrawer />
    </PageContainer>
  )
}
